import { useNavigate } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { icons } from "assets/AssetHelper";
import { AppForm, AppFormField, SubmitButton } from "components/Molecules/Form";
import { resetPasswordSchema } from "common/utils/schemas";
import { useDispatch, useSelector } from "react-redux";
import Loader from "components/Atoms/SharedComponents/Loader/Loader";
import { resetPasswordRequest } from "services/modules/authenticate";
import { toast } from "react-toastify";

export default function ResetPasswordForm({
  hideIcon,
  setResetPasswordStep,
  customAction,
  userType = "admin_user",
}) {
  const { t } = useTranslation();
  const email = localStorage.getItem("forgetPasswordEmail");
  const token = localStorage.getItem("verification-token");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { load } = useSelector((state) => state.authenticate);

  const handleFormSubmit = (values, { setSubmitting }) => {
    const action = () => {
      if (customAction) {
        setResetPasswordStep({ action: false, step: null });
        toast.success(t("auth.reset_password.success_toast"));
      } else {
        navigate("/reset-password-success");
      }

      localStorage.removeItem("verification-token");
    };
    setSubmitting(false);
    const requestData = {
      body: {
        user: {
          email,
          password: values?.password,
          password_confirmation: values?.confirmPassword,
        },
        device: {
          device_type: "android",
          fcm_token: "{{fcm_token}}",
        },
      },
      headers: {
        "verification-token": token,
      },
      action,
    };

    dispatch(resetPasswordRequest({ ...requestData, user_type: userType }));
  };

  return (
    <>
      <Loader open={load?.loading} />
      <Stack sx={{ gap: 5 }}>
        {!hideIcon && (
          <Box
            component="img"
            src={icons.lockIcon}
            sx={{ width: "60px", height: "80px" }}
          />
        )}

        <Typography fontFamily="Cairo" fontSize="32px" fontWeight="400">
          {t("auth.reset_password.title")}
        </Typography>
        <AppForm
          initialValues={{
            password: "",
            confirmPassword: "",
          }}
          validationSchema={resetPasswordSchema}
          onSubmit={(values, { setSubmitting }) => {
            handleFormSubmit(values, { setSubmitting });
          }}
        >
          <Stack sx={{ gap: 5 }}>
            <AppFormField
              label={t("auth.reset_password.password_label")}
              name="password"
              type="password"
              labelStyle={{ fontSize: "18px" }}
              placeholder="**********"
            />
            <AppFormField
              label={t("auth.reset_password.confirm_password_label")}
              name="confirmPassword"
              type="password"
              labelStyle={{ fontSize: "18px" }}
              placeholder="**********"
            />
            <Stack sx={{ gap: 4 }}>
              <SubmitButton>{t("auth.reset_password.submit")}</SubmitButton>
            </Stack>
          </Stack>
        </AppForm>
      </Stack>
    </>
  );
}
